import axios from "@axios";
import Vue from "vue";
import CallContent from "@/components/toastification/CallContent.vue";
import store from "..";
import LayoutApi from "@/libs/LayoutApi";
import { SLOT_TYPES } from "@/config/layoutConfig";

export default {
  namespaced: true,
  state: {
    items: []
  },
  getters: {
    getItems(state) {
      return state.items;
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get("/v1/pbx_devices", { params });

      if (!data) {
        return [];
      }

      commit("setData", data.data);
      return data;
    },
  },
};
